// src/pages/ManageGroups.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useStore } from '../store';

export default function ManageGroups() {
  const navigate = useNavigate();
  const { groups, groupsLoading, fetchGroups, deleteGroup } = useStore();
  const [search, setSearch] = useState('');

  useEffect(() => { fetchGroups(); }, []);

  const filtered = groups.filter(g => g.name.toLowerCase().includes(search.toLowerCase()));

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div className="page-header">
        <div>
          <span className="page-title">Groups</span>
          <span style={{ fontSize: 11, color: '#8892a4', marginLeft: 14 }}>1 — {filtered.length} of {groups.length}</span>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="filter-pill">❓</button>
          <button className="btn btn-primary" onClick={() => navigate('/groups/create')}>+ Create Group</button>
        </div>
      </div>
      <div className="toolbar">
        <input type="checkbox" style={{ accentColor: '#0f766e' }} />
        <div className="search-box"><span style={{ color: '#aaa' }}>🔍</span><input placeholder="Search a group" value={search} onChange={e => setSearch(e.target.value)} /></div>
      </div>
      <div style={{ flex: 1, overflowY: 'auto' }}>
        {groupsLoading ? <div className="loading-center"><div className="spinner" /></div> :
          filtered.length === 0 ? (
            <div className="empty-state">
              <span style={{ fontSize: 40 }}>◎</span>
              <h3>No groups yet</h3>
              <p>Create groups to organize your accounts and publish to multiple platforms at once</p>
              <button className="btn btn-primary" onClick={() => navigate('/groups/create')}>Create Group</button>
            </div>
          ) : (
            <table className="data-table">
              <thead><tr><th><input type="checkbox" style={{ accentColor: '#0f766e' }}/></th><th>Group Name ↑</th><th>Accounts</th><th>Group Description</th><th>Created By</th><th></th></tr></thead>
              <tbody>
                {filtered.map(g => (
                  <tr key={g.id}>
                    <td><input type="checkbox" style={{ accentColor: '#0f766e' }}/></td>
                    <td><span style={{ color: '#0f766e', fontWeight: 500, cursor: 'pointer' }} onClick={() => navigate(`/groups/edit/${g.id}`)}>{g.name}</span></td>
                    <td><span style={{ display: 'inline-block', padding: '2px 10px', background: '#f0f1f5', borderRadius: 10, fontSize: 11, color: '#4a5568' }}>{g.account_count || 0} Account{g.account_count !== 1 ? 's' : ''}</span></td>
                    <td style={{ color: '#aaa' }}>{g.description || '—'}</td>
                    <td style={{ color: '#555' }}>{g.created_by_name || '—'}</td>
                    <td>
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button className="btn btn-outline" style={{ fontSize: 11, padding: '4px 10px' }} onClick={() => navigate(`/groups/edit/${g.id}`)}>✏ Edit</button>
                        <button className="btn btn-danger" style={{ fontSize: 11, padding: '4px 8px' }} onClick={async () => { if (window.confirm(`Delete "${g.name}"?`)) { await deleteGroup(g.id); toast.success('Group deleted'); } }}>🗑</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )
        }
      </div>
    </div>
  );
}
